import React from 'react'
import ImageType from '../../image_type'

const ImageCell = ({ text, image }) =>
{
  return (
    <div style={{display:'inline-block', height: '100%', verticalAlign:'middle', whiteSpace:'nowrap'}}>
      <ImageType typeId={image} alt={text} style={{verticalAlign:'middle'}} />{text}
    </div>
  )
}

export default ImageCell
